import React from 'react';

import PageHeader from '../../components/layout/PageHeader';
import MentorAnalyticsDashboard from '../../components/mentor/dashboard/MentorAnalyticsDashboard';
import { pageDescriptions } from '../../data/pageDescriptions';

/**
 * /mentor/dashboard — cohort analytics dashboard.
 *
 * Replaces the old flat KPI page (3 tiles + Mentee Performance table + quick
 * links) with the analytics-rich layout described in
 * `MentorAnalyticsDashboard`. The invite code, registration link, and quick-
 * action tiles that used to live at the top of this page now sit in the
 * dashboard's footer band so the cohort analytics are the first thing the
 * mentor sees.
 */
const MentorDashboard = () => {
  const copy = pageDescriptions['/mentor/dashboard'];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <PageHeader
          title={copy.title}
          description={copy.description}
          whatYouCanDo={copy.whatYouCanDo}
          whatYouShouldDo={copy.whatYouShouldDo}
        />
      </div>
      <MentorAnalyticsDashboard />
    </div>
  );
};

export default MentorDashboard;
